import type { ReactNode } from 'react';

/** Inspector section: overline title (muted) + content (gap 12). */
export function Section({ title, right, children }: { title: string; right?: ReactNode; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h3 className="t-overline text-muted">{title}</h3>
        {right}
      </div>
      {children}
    </section>
  );
}
